// ©2024 Austin App House. All rights reserved.
import React from 'react';
import ClientApprovalRow from './ClientApprovalRow';

const ClientApprovalField = field => {
  const editField = (clientApprovalCode, index) => {
    field.toggleModal(
      true,
      'editClientApprovalCodeModal',
      false,
      { index, field: clientApprovalCode, input: field.input },
    );
  };

  const removeField = fieldIndex => {
    const newValue = field.input.value.filter((item, index) => index !== fieldIndex);
    field.input.onChange(newValue);
  };

  return (
    <>
      <div className="add_btns">
        <button
          type="button"
          className="standard_btn icon_plus"
          aria-label="add client approval code"
          onClick={() => field.toggleModal(
            true,
            'createOrAddClientApprovalCodeToWorkOrder',
            false,
            { input: field.input },
          )}
        >Add Client Approval Code</button>
      </div>
      <div className="fields_group">
        <div className="block_title">Client Approval Code</div>
        <table className="custom_table">
        <thead>
          <tr>
            <th className="arrival">Name</th>
            <th className="site">Required Y/N</th>
            <th className="completion">Actions</th>
          </tr>
        </thead>
        <tbody className="font12">
          {
            field?.input?.value?.length
              ? field.input.value.map((customField, index) => (
                <ClientApprovalRow
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${customField.name} - ${index}`}
                  customField={customField}
                  removeField={() => removeField(index)}
                  editField={() => editField(customField, index)}
                />
              ))
              : (
                <tr>
                  <td colSpan={3} className="empty_state">No client approval codes added.</td>
                </tr>
              )
          }
        </tbody>
      </table>
      </div>
    </>
  );
};

export default ClientApprovalField
;
